"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadTranslationsFile = exports.fetchExcelInfo = exports.fetchLanguage = void 0;
const t = require("io-ts");
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const actionTypes = require("../actionTypes/translations");
const actions = require("../actions/translations");
const sok_types_1 = require("@caddigital/sok-types");
const TranslationsUtil = require("../utils/translation");
const errorHandling_1 = require("../utils/errorHandling");
function fetchLanguage(action$, _store, { ajax, getToken, frontUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${frontUrl}translation/lang/${action.payload.language}`,
        allowCache: true
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = sok_types_1.Translations.iLocalization.decode(x.response);
        const act = validate.fold((x) => actions.fetchLanguageFailed((0, errorHandling_1.parseValidationError)(x)), (t) => {
            TranslationsUtil.setTranslation(t, action.payload.isProduction);
            return actions.fetchLanguageSuccess(action.payload.language);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.fetchLanguageFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchLanguage = fetchLanguage;
function fetchExcelInfo(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.FETCH_EXCEL_INFO_REQUEST), (0, operators_1.mergeMap)(() => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/admin/translations/excelinfo/`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = t
            .interface({
            user: sok_types_1.User.iUser,
            timestamp: t.string
        })
            .decode(x.response);
        const act = validate.fold(() => actions.fetchExcelInfoFailed('failed to fetch excel info'), (t) => {
            return actions.fetchExcelInfoSuccess(t);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.fetchExcelInfoFailed(error))))));
}
exports.fetchExcelInfo = fetchExcelInfo;
const getFormData = (files) => {
    const form = new FormData();
    files.length > 0 && form.append('file', files[0].file, files[0].name);
    return form;
};
function uploadTranslationsFile(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.UPLOAD_TRANSLATIONS_FILE), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            Authorization: getToken()
        },
        method: 'POST',
        body: getFormData(request.payload.file),
        url: `${baseUrl}api/admin/translations/upload/`
    }).pipe((0, operators_1.mergeMap)((x) => {
        if (x.status !== 200) {
            return (0, rxjs_1.of)(actions.uploadTranslationsFileFailed('failed to upload translations file'));
        }
        const userLanguage = store.value.auth.current.user
            .chain((y) => y.language === undefined
            ? fp.option.none
            : fp.option.some(y.language))
            .getOrElse('en');
        return (0, rxjs_1.merge)((0, rxjs_1.of)(actions.uploadTranslationsFileSuccess('OK'), actions.fetchExcelInfoRequest(), actions.fetchLanguageRequest(userLanguage)), (0, rxjs_1.of)(actions.setStandby()).pipe((0, operators_1.delay)(2500)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.uploadTranslationsFileFailed(error))))));
}
exports.uploadTranslationsFile = uploadTranslationsFile;
//# sourceMappingURL=translations.js.map